import React from "react";

import logo from "./logo.svg";

const Logo = ({ width = 80 }) => <img width={width} src={logo} alt="logo" />;

export default Logo;
